/**
 * 🔴 A HORA DO AUVO — um formatador só, para a tela, os PDFs, a planilha e os e-mails (adendo unificado, V1).
 *
 * O Auvo manda a hora de PAREDE de Brasília, SEM fuso: `"2026-09-12T12:13:39"` é 12h13 em Brasília. **Medido em
 * 06/10/2026** na cópia do beta: das tarefas criadas desde setembro, 143 de 168 chegaram ao nosso servidor exatamente
 * 3 horas depois em UTC (`visto_primeiro_iso` − `creationDate` = 3 h) — a hora do Auvo é Brasília.
 *
 * ⚠️ O defeito que isto conserta: a tela passava o texto por `new Date()`/formatador de fuso, que lê texto sem fuso
 * como UTC e tirava 3 horas (12/09 09:13 na tela, 12:13 no PDF e no Auvo). ❌ Hora do Auvo NUNCA passa por `Date`:
 * os dígitos já são a resposta. Texto que não tem o formato devolve "—".
 */
const PAREDE = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/;
const SO_DATA = /^(\d{4})-(\d{2})-(\d{2})$/;

export interface HoraDoAuvo {
  /** "12/09/2026" */
  data: string;
  /** "12/09" */
  diaEMes: string;
  /** "12:13" */
  hora: string;
  /** "12/09/2026 12:13" */
  dataHora: string;
  /** "12/09 12:13" */
  curta: string;
}

/** A hora de parede do Auvo escrita para gente. `null` ou texto sem o formato: tudo "—". */
export function horaDoAuvo(texto: string | null | undefined): HoraDoAuvo {
  const m = PAREDE.exec(texto ?? '');
  if (m) {
    const [, a, mes, d, h, mi] = m;
    return { data: `${d}/${mes}/${a}`, diaEMes: `${d}/${mes}`, hora: `${h}:${mi}`, dataHora: `${d}/${mes}/${a} ${h}:${mi}`, curta: `${d}/${mes} ${h}:${mi}` };
  }
  const so = SO_DATA.exec(texto ?? '');
  if (so) {
    const [, a, mes, d] = so;
    return { data: `${d}/${mes}/${a}`, diaEMes: `${d}/${mes}`, hora: '—', dataHora: `${d}/${mes}/${a}`, curta: `${d}/${mes}` };
  }
  return { data: '—', diaEMes: '—', hora: '—', dataHora: '—', curta: '—' };
}
